import ImageNonResponsive from "components/atoms/ImageNonResponsive";
import Button from "components/atoms/Button";
import Order from "components/organisms/Order";
import AgeSelector from "components/organisms/AgeSelector";
import { navigateToLessonsPlan } from "utils/navigateToLessonsPlan";

import "./styles.scss";
import { useHypercomments } from "./useHypercomments";

const RecursiveContent = ({ content, card, baseUrl }) => {
  // extract to a separate component
  useHypercomments(card);

  const getContent = (cnt) => {
    return typeof cnt?.value === "string" ? (
      <span
        dangerouslySetInnerHTML={{ __html: cnt?.value }}
        className="text"
      ></span>
    ) : (
      <RecursiveContent content={cnt?.value} />
    );
  };
  return (
    Array?.isArray(content) && (
      <span className="recursive-content">
        {content?.map((entry, index) => {
          switch (entry?.type) {
            // TODO:
            // "expandable",
            //    "action",
            // "slider",
            case "expandable":
              return (
                <div key={`expandable-${index}`} className="expandable">
                  {getContent(entry)}
                </div>
              );
            case "action":
              return (
                <div key={`action-${index}`} className="action">
                  {getContent(entry)}
                </div>
              );
            case "content":
              return (
                <div key={`content-${index}`} className="content">
                  {getContent(entry)}
                </div>
              );
            case "header1":
              return (
                <h1 key={`header1-${index}`} className="header1">
                  {getContent(entry)}
                </h1>
              );
            case "header2":
              return (
                <h2 key={`header2-${index}`} className="header2">
                  {getContent(entry)}
                </h2>
              );
            case "p":
              return (
                <p key={`p-${index}`} className="p">
                  {getContent(entry)}
                </p>
              );
            case "text":
              return typeof entry?.value === "string" ? (
                <span key={`text-${index}`} className="text">
                  {getContent(entry)}
                </span>
              ) : (
                <div key={`text-paragraph-${index}`} className="text paragraph">
                  {getContent(entry)}
                </div>
              );
            case "small":
              return typeof entry?.value === "string" ? (
                <span key={`small-${index}`} className="small">
                  {getContent(entry)}
                </span>
              ) : (
                <div key={`small-${index}`} className="small">
                  {getContent(entry)}
                </div>
              );
            case "strong":
              return (
                <span key={`strong-${index}`} className="strong">
                  {getContent(entry)}
                </span>
              );
            case "highlight":
              return (
                <span key={`highlight-${index}`} className="highlight">
                  {getContent(entry)}
                </span>
              );
            case "lineThrough":
              return (
                <span key={`line-through-${index}`} className="line-through">
                  {getContent(entry)}
                </span>
              );
            case "blockquote":
              return (
                <div key={`blockquote-${index}`} className="blockquote">
                  {getContent(entry)}
                </div>
              );
            case "unorderedList":
              return (
                <ul key={`unordered-list-${index}`} className="unordered-list">
                  {getContent(entry)}
                </ul>
              );
            case "listItem":
              return (
                <li key={`list-item-${index}`} className="list-item">
                  {getContent(entry)}
                </li>
              );
            case "image":
              return (
                <ImageNonResponsive
                  key={`image-${index}`}
                  className="image"
                  filename={`content/${entry?.value}`}
                />
              );
            case "button":
              const onPressButtonType = (type) =>
                ({
                  next: () => card?.next(),
                  skipOne: () => card?.goTo(card.currentIndex + 2),
                  endLesson: () => navigateToLessonsPlan(baseUrl),
                  salesPage: () => navigateToLessonsPlan(""), // TODO: link to the actual Sales page
                  skipToContent: () => {
                    const anchor =
                      document.querySelectorAll("[id=paymentTable]")[1];
                    anchor.scrollIntoView({
                      behavior: "smooth",
                      block: "start",
                      inline: "nearest",
                    });
                  },
                }[type]);
              return (
                <Button
                  key={`button-${index}`}
                  onClick={onPressButtonType(entry?.target)}
                  text={JSON.stringify(entry?.value).replace(/"/g, "")}
                  className="available"
                />
              );
            case "video":
              return (
                <iframe
                  key={`video-${index}`}
                  type="text/html"
                  width="640"
                  height="360"
                  title="video"
                  src={`https://www.youtube.com/embed/${entry?.value}?autoplay=0&rel=0&showinfo=0`}
                  frameBorder="0"
                  originwhitelist={["*"]}
                  className="video"
                  javascriptenabled={"true"}
                ></iframe>
              );
            case "link":
              const isExternalOrEmail =
                entry?.href.includes("https") || entry?.href.includes("@");
              const href = isExternalOrEmail ? entry?.href : "#";
              const onPress = (e) => {
                const anchor =
                  document.querySelectorAll("[id=paymentTable]")[1];
                if (!isExternalOrEmail) {
                  e.preventDefault();
                  anchor.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                    inline: "nearest",
                  });
                }
              };
              return (
                <a
                  key={`link-${index}`}
                  className="link"
                  href={href}
                  onClick={onPress}
                >
                  {entry?.value}
                </a>
              );
            case "review":
              return (
                <div key={`review-${index}`} className="review">
                  <ImageNonResponsive
                    className="review-avatar"
                    filename={`content/${entry?.avatar}`}
                  />

                  <i
                    className="content"
                    dangerouslySetInnerHTML={{ __html: entry?.value }}
                  ></i>
                </div>
              );
            case "paymentTable":
              return (
                <Order
                  key={`order-${index}`}
                  globals={entry?.value}
                  authUser={card?.authUser}
                  index={index}
                />
              );
            case "hyperComments":
              return (
                <div
                  key={`hyper-comments-${index}`}
                  className="hyper-comments"
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                ></div>
              );
            case "ageSelector":
              return (
                <AgeSelector
                  key={`age-selector-${index}`}
                  card={card}
                  baseUrl={baseUrl}
                  initialData={entry?.initialData || {}}
                />
              );
            case "id":
              return (
                <span
                  key={`span-${index}`}
                  id={entry?.value ?? "paymentTable"}
                />
              );

            default:
              return (
                <span key={`text-${index}`} className="text">
                  {getContent(entry)}
                </span>
              );
          }
        })}
      </span>
    )
  );
};

export default RecursiveContent;
